import { useMemo } from 'react';

import { compareBigNumbers, subtractFixedDecimals } from '@/shared/utils/helpers';
import { useModal } from '@/features/Modals';

export const useMaxBalance = () => {
    const { modalProps } = useModal();

    const {
        balance: userBalance,
        totalDeposited,
        totalDepositThreshold,
        decimals,
    } = modalProps || {};

    return useMemo(() => {
        const limit = subtractFixedDecimals(
            totalDepositThreshold as string,
            totalDeposited!,
            decimals,
        );

        return compareBigNumbers(userBalance, limit, decimals) < 0 ? userBalance : limit;
    }, [decimals, userBalance, totalDepositThreshold, totalDeposited]);
};
